import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'

/**
 * The thumbnail column of an item-level card: full width stacked on mobile, a fixed 100px rail
 * beside the text from tablet up. Shared by every selectable item card so they keep the same
 * proportions — the text column's width is whatever this leaves behind, so a card that renders it
 * and one that does not are visibly different sizes.
 */
const ImageWrapper = styled.div`
  width: 100%;
  ${mediaQueryUp.tablet} {
    width: ${rem(100)};
  }
`

interface Props {
  id?: string
}

export default function LesaPurchaseSummaryImage({ id }: Props) {
  if (!id) return null

  return (
    <ImageWrapper>
      <ImageWithReservedSpace id={id} />
    </ImageWrapper>
  )
}
